// Sizes from @/constants/thumbnails

/**
 * Image caching uses IndexedDB because it's a lot of data to just have in memory.
 * - The state here shows existence in indexedDB
 */
export const getDefaultState = () => {
  return {
    /**
     * Maps of images (key) to bool that determines if image exists in cache (indexedDB)
     * for 3 variations of image:
     * - 3 thumbnail sizes
     * - Original image
     *
     * [imageKey<string>] : {
     *    [TALL]: <bool>
     *    [MEDIUM]: <bool>
     *    [SHORT]: <bool>
     *    [ORIGINAL]: <bool>
     * }
     */
    imageCache: {
    },

    /**
     * Map of images (key) to promises for different variations of the image:
     * - 3 thumbnail sizes
     * - Original image
     *
     *    [imageKey<string>] : {
     *      [TALL]: <Promise>
     *      [MEDIUM]: <Promise>
     *      [SHORT]: <Promise>
     *      [ORIGINAL]: <Promise>
     *    }
     * }
     */
    fetchPromises: {
    },

    /**
     * Map of attachment keys to promises for fetching the info
     * - info being thumbnail sizes + urls
     * - getAttachmentInfo() is the API call and is spammed if we have components using the same image.
     *   > Example, same image in gallery/listing mode, both makes identical request.
     *
     * <attachmentKey>: <Promise>
     */
    attachmentFetchPromises: {
    },
  };
};

export const state = getDefaultState();